import React from 'react';
import { useTranslation, Trans } from 'react-i18next'; // Trans'ı import et
import { Link } from 'react-router-dom'; // Link'i import et
import './StaticPages.css';

const MembershipTermsPage = () => {
  const { t } = useTranslation();

  return (
    <div className="page-container static-page text-page">
      <div className="static-header">
                <h1>{t('membership_terms_title')}</h1>
                 <p className="last-updated">{t('last_updated_membership')}</p>
            </div>
	  
      <div className="text-content">
        <h3>{t('terms_section1_title')}</h3>
        <p>{t('terms_section1_p1')}</p>

        <h3>{t('terms_section2_title')}</h3>
        <p>{t('terms_section2_p1')}</p>
        
        <h3>{t('terms_section3_title')}</h3>
        <p>{t('terms_section3_p1')}</p>
        <p>{t('terms_section3_p2')}</p>
        
        <h3>{t('terms_section4_title')}</h3>
        <p>{t('terms_section4_p1')}</p>

        <h3>{t('terms_section5_title')}</h3>
        <p>
          <Trans i18nKey="terms_section5_p1">
            <Link to="/privacy-policy" target="_blank" rel="noopener noreferrer" className="text-link" />
          </Trans>
        </p>

        {/* YENİ MADDELER BURAYA EKLENDİ */}
        <h3>{t('terms_section6_title')}</h3>
        <p>{t('terms_section6_p1')}</p>
        <p>{t('terms_section6_p2')}</p>
        
        <h3>{t('terms_section7_title')}</h3>
        <p>{t('terms_section7_p1')}</p>
      </div>
    </div>
  );
};

export default MembershipTermsPage;